import { FC } from 'react';
import { Box } from '@mui/material';
import Link from 'next/link';
import { headerNavStyles } from './header-nav.styles';
import AppButton from '../app-button/button.component';
import ExternalLink from '../../links/External-link';
import { TYPEFORM_URL, SHOP_SWEATPALS_URL, BOOK_DEMO_URL } from '../../../constants';
import useLink from '../../../utils/hooks/useLink';
import { clsx, useStyles } from '@sweatpals/react-ui-kit';
import { observer } from 'mobx-react-lite';
import { authStore } from 'stores';

export interface HeaderNavProps {
	authText?: string;
	onAuthClick?(): void;
}

export const HeaderNav: FC<HeaderNavProps> = observer((props) => {
	const { authText, onAuthClick } = props;

	const currentUser = authStore.user;

	const { makeDashboardLink } = useLink();

	const styles = useStyles(headerNavStyles);

	return (
		<Box component="nav" sx={styles.root}>
			<Box sx={styles.list}>
				<Box sx={clsx(styles.links, styles.hideOnMobileWidth)}>
					<Link href="/events" passHref legacyBehavior>
						<Box sx={clsx(styles.textNowrap, styles.link)}>Discover</Box>
					</Link>
					<Link href="/about" passHref legacyBehavior>
						<Box sx={clsx(styles.textNowrap, styles.link)}>About</Box>
					</Link>
					<Link href="/download" passHref legacyBehavior>
						<Box sx={clsx(styles.textNowrap, styles.link)}>Get the App</Box>
					</Link>
					<ExternalLink href={TYPEFORM_URL} >
						<Box sx={clsx(styles.textNowrap, styles.link)}>Grow your community</Box>
					</ExternalLink>
					<ExternalLink href={SHOP_SWEATPALS_URL}>
						<Box sx={clsx(styles.textNowrap, styles.link)}>Shop</Box>
					</ExternalLink>
					<ExternalLink href={BOOK_DEMO_URL}>
						<Box sx={clsx(styles.textNowrap, styles.link)}>Book a demo</Box>
					</ExternalLink>
				</Box>
				<Box display={'flex'} sx={{ gap: '8px' }}>
					<Box sx={styles.hideOnMobileWidth} onClick={onAuthClick}>
						<Link href={makeDashboardLink()} passHref legacyBehavior>
							<AppButton sx={clsx(styles.textNowrap)} color="secondary">
								{authText ?? 'Host login'}
							</AppButton>
						</Link>
					</Box>
					<Box sx={styles.hideOnMobileWidth}>
						<Link href='/create/event' legacyBehavior>
							<AppButton sx={clsx(styles.textNowrap, styles.textNoDecoration)} color="secondary">
								🚀 Launch an event
							</AppButton>
						</Link>
					</Box>
				</Box>

			</Box>
		</Box>
	);
});

export default HeaderNav;
